import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import Barchart from "../charts/Barchart";
import Histogramchart from "../charts/Histogramchart";

function Productsdistribution({ product_distribution, product_prices, filter }) {
    const { t } = useTranslation();
    const [type, setType] = useState("sales");

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Products Distribution")} ({(filter.dateRange || "30") + " days"})</h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="col-6 d-flex justify-content-end">
                        <div className="btn-group">
                            <button className={cx("btn", { "btn-primary": type === "sales", "btn-light": type !== "sales"})} onClick={() => setType("sales")} >
                                {t("Sales")}
                            </button>
                            <button className={cx("btn", { "btn-primary": type === "gmv", "btn-light": type !== "gmv"})} onClick={() => setType("gmv")} >
                                {t("GMV")}
                            </button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex col">
                            <Barchart product_distribution={product_distribution} type={type} filter={filter} />
                        </div>
                        <div className="d-flex col">
                            <Histogramchart product_prices={product_prices} filter={filter} />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Productsdistribution);